import React from "react";

const RedemptionProductList = React.lazy(() => import('src/pages/redemption_product/RedemptionProductList'));
const AddRedemptionProduct = React.lazy(() => import('src/pages/redemption_product/AddRedemptionProduct'));
const EditRedemptionProduct = React.lazy(() => import('src/pages/redemption_product/EditRedemptionProduct'));
// const ViewRedemptionProduct = React.lazy(() => import('src/pages/redemption_product/ViewRedemptionProduct'));

const routes = [
    { path: '/dashboard/redemption-product-list/add', name: 'Add', element: AddRedemptionProduct },
    { path: '/dashboard/redemption-product-list/edit', name: 'Edit', element: EditRedemptionProduct },
    // { path: '/dashboard/redemption-product-list/view/:id', withParam: true, exact: true, name: "", element: ViewRedemptionProduct },
    { path: '/dashboard/redemption-product-list', name: 'Product Management', element: RedemptionProductList },
];

export default routes;